module.exports = __webpack_public_path__ + "img/AL8000-2-EN.05278981.jpg";